import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cur } from '@/lib/currency';

export const VAT_OPTIONS = [
  { value: 'standard', label: 'Standard-rated (VAT on invoice)' },
  { value: 'zero_rated', label: 'Zero-rated (0%)' },
  { value: 'exempt', label: 'Exempt' },
  { value: 'no_vat', label: 'No VAT / not a VAT invoice' },
];

// Fields sent to POST /expenses. Amount is always the gross invoice total.
export const vatPayload = (v) => ({
  vat_treatment: v.vat_treatment || undefined,
  supplier_vat_number: v.vat_treatment === 'standard' ? (v.supplier_vat_number || undefined) : undefined,
  ...(v.vat_treatment === 'standard' && v.invoice_number ? { invoice_number: v.invoice_number } : {}),
});

export const vatError = (v, { needInvoice = true } = {}) => {
  if (!v.vat_treatment) return 'Select the VAT treatment shown on the supplier invoice';
  if (v.vat_treatment === 'standard' && needInvoice && !(v.invoice_number || '').trim()) return 'Enter the supplier invoice number';
  return null;
};

export const VatTreatmentFields = ({ value, onChange, amount, rate = 15, withInvoice = true, compact = false, testPrefix = 'vat' }) => {
  const gross = parseFloat(amount) || 0;
  const net = gross / (1 + rate / 100);
  const std = value.vat_treatment === 'standard';
  return (
    <div className={`rounded-lg border bg-muted/40 ${compact ? 'p-2 space-y-2' : 'p-3 space-y-2'}`} data-testid={`${testPrefix}-treatment-fields`}>
      <div className={compact ? '' : 'flex flex-wrap items-end gap-3'}>
        <div className="flex-1 min-w-[200px]">
          <Label className="text-xs">VAT treatment * <span className="text-muted-foreground">(from the supplier invoice)</span></Label>
          <select value={value.vat_treatment || ''} onChange={(e) => onChange({ vat_treatment: e.target.value })}
            className="w-full h-9 text-sm border rounded-md px-2 bg-background" data-testid={`${testPrefix}-treatment-select`}>
            <option value="" disabled>Select…</option>
            {VAT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        {std && withInvoice && (
          <div className="flex-1 min-w-[160px]">
            <Label className="text-xs">Supplier invoice no. *</Label>
            <Input value={value.invoice_number || ''} onChange={(e) => onChange({ invoice_number: e.target.value })} className="h-9" data-testid={`${testPrefix}-invoice-input`} />
          </div>
        )}
        {std && (
          <div className="flex-1 min-w-[180px]">
            <Label className="text-xs">Supplier VAT no.</Label>
            <Input value={value.supplier_vat_number || ''} inputMode="numeric" placeholder="15 digits (uses supplier record if empty)"
              onChange={(e) => onChange({ supplier_vat_number: e.target.value.replace(/\D/g, '').slice(0, 15) })} className="h-9" data-testid={`${testPrefix}-supplier-vat-input`} />
          </div>
        )}
      </div>
      <p className="text-[11px] text-muted-foreground" data-testid={`${testPrefix}-split-preview`}>
        Amount entered is the gross invoice total.{' '}
        {std && gross > 0
          ? <>Net {cur()} {net.toFixed(2)} + VAT {cur()} {(gross - net).toFixed(2)} = {cur()} {gross.toFixed(2)} (branch rate applies: SA 15%, BH 10%).</>
          : std ? 'Enter the gross amount to see the net / VAT split.' : value.vat_treatment ? 'No input VAT is recorded for this treatment.' : ''}
      </p>
    </div>
  );
};
